import React, { Component } from 'react'
import { Select, Input, DatePicker } from 'hljd'
import store from '../store'
import SearchBar from '@common/SearchBar'
import { observer } from 'mobx-react'
const RangePicker = DatePicker.RangePicker
const { Item } = SearchBar
const Option = Select.Option

@observer
export default class extends Component {
  render() {
    return (
      <SearchBar
        store={store}
        noNeed={['date', 'lead_name', 'lead_phone', 'order_no']}
      >
        <Item name="lead_phone" label="客户手机">
          <Input />
        </Item>

        <Item name="lead_name" label="客户姓名">
          <Input />
        </Item>

        <Item name="order_no" label="派单号">
          <Input />
        </Item>

        <Item name="type" label="结算类型">
          <Select style={{ width: 120 }}>
            <Option value="1">首次结算</Option>
            <Option value="2">多退少补</Option>
            <Option value="3">退单</Option>
          </Select>
        </Item>

        <Item name="date" label="账单日">
          <RangePicker placeholder={['开始时间', '结束时间']} />
        </Item>
      </SearchBar>
    )
  }
}
